import { computed } from 'vue'

import { ContactUtil } from '@/utils/Contact'

import usePartner from '@/hooks/usePartner'
import { useI18n } from 'vue-i18n'

// Hooks
const { partner } = usePartner()

function processChat({ chatOpeningTime }, tm) {
  return {
    active: ContactUtil.amIOpen(chatOpeningTime),
    enabled: chatOpeningTime.length > 0,
    times: chatOpeningTime.map(line => processOpening(line, tm)),
  }
}

function processCoBrowsing({ coBrowsingOpeningTime }, tm) {
  return {
    active: ContactUtil.amIOpen(coBrowsingOpeningTime),
    enabled: coBrowsingOpeningTime.length > 0,
    times: coBrowsingOpeningTime.map(line => processOpening(line, tm)),
  }
}

function processOpening(line, tm) {
  const startDay = tm(`date.days.${line.start}`)
  const endDay = tm(`date.days.${line.end}`)

  return {
    days: `${startDay} - ${endDay}`,
    hours: `${line.startTime} - ${line.endTime}`,
  }
}

function processPhone({ name, phoneNumber, openingTime }, tm) {
  return {
    name,
    active: ContactUtil.amIOpen(openingTime),
    enabled: true,
    nr: phoneNumber,
    times: openingTime.map(line => processOpening(line, tm)),
  }
}

const contactInfo = computed(() => {
  const { tm } = useI18n()

  if (!partner.value) return

  const data = partner.value.contact

  if (!data) return

  return {
    alva: data.alva,
    chat: data.chatOpeningTime ? processChat(data, tm) : false,
    cobrowsing: data.coBrowsingOpeningTime ? processCoBrowsing(data, tm) : false,
    email: data.email,
    phone: data.openingTime ? processPhone(data, tm) : false,
  }
})

export default function useContact() {
  return {
    contactInfo,
  }
}
